export default __webpack_public_path__ + "static/media/gaoler.2bcdf05b.png";